import { render, staticRenderFns } from "./inspectionPointList.vue?vue&type=template&id=40665ea5&scoped=true"
import script from "./inspectionPointList.vue?vue&type=script&lang=js"
export * from "./inspectionPointList.vue?vue&type=script&lang=js"
import style0 from "./inspectionPointList.vue?vue&type=style&index=0&id=40665ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665ea5",
  null
  
)

export default component.exports